import React from 'react';
import useSWR from 'swr';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from "react-router-dom";
import BookingForm from "./BookingForm";
import SoldOut from "./SoldOut";
import Finished from "./Finished";
import Highlights from "./Highlights";
import Basics from "./Basics";
import PackageHeader from "./PackageHeader";
import PackageDetailsTab from "./PackageDetailsTab";

function PackageDetailsWrap(props) {
  // API configuration constants
  const API_URL = `${process.env.REACT_APP_API_FOLDER}get_${props.ctype}_workshop/${props.item_id}`;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;

  // SWR fetcher
  const fetcher = (url) =>
    fetch(url, {
      headers: { 'X-API-TOKEN': API_TOKEN }
    }).then((res) => {
      if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
      return res.json();
    });

  // Data fetching via SWR
  const { data: workshop, error, isLoading } = useSWR(API_URL, fetcher);

  // Loading skeleton
  if (isLoading) {
    return (
      <div className="package-details-wrapper pt-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <Skeleton height={40} count={1} style={{ marginBottom: '1rem' }} />
              <Skeleton height={300} count={1} />
            </div>
            <div className="col-lg-4">
              <Skeleton height={20} count={4} style={{ marginBottom: '0.5rem' }} />
              <Skeleton height={300} count={1} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    console.error('API Error:', error);
    return <p className="text-danger">Error loading workshop: {error.message}</p>;
  }

  return (
    <>
      <div className="package-details-wrapper pt-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="tour-package-details">
                <PackageHeader workshop={workshop} />
                <PackageDetailsTab workshop={workshop} />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="package-sidebar">
                <Highlights workshop={workshop} />
                <Basics workshop={workshop} />
                {workshop && (
                  workshop.booking_cutoff_time < Math.floor(Date.now() / 1000) ? (
                    <Finished ctype={workshop.ctype} srcid={workshop.id} artforms={workshop.artforms} />
                  ) : (
                    workshop.hasplaces
                      ? <BookingForm workshop={workshop} />
                      : <SoldOut ctype={workshop.ctype} srcid={workshop.id} artforms={workshop.artforms} />
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PackageDetailsWrap;
